// this file added by Bearer Web Developer
import React from "react";
import styles from './edit.module.scss';
import { Button } from "@mui/material";
import { useAppState } from "../../../../../../../states/app-state";
import { useThemeMode } from "../../../../../../../states/contexts/theme";

const Edit: React.FC = () => {

    const appState = useAppState();
    const { editEmailVertification } = appState;
    const handleClick = () => {
        editEmailVertification?.setOpen(true);
    }
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.edit_part} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <Button className={styles.edit} disableRipple={true} onClick={handleClick}>Edit</Button>
        </div>
    )
}
export default Edit;